import React, { useEffect, useState, useCallback } from "react";
import { Plus, Search, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api, { notifyError } from "@/lib/api";
import PlatformLayout from "@/components/PlatformLayout";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import TenantTable from "./tenants/TenantTable";
import CreateTenantWizard from "./tenants/CreateTenantWizard";
import DeleteTenantDialog from "./tenants/DeleteTenantDialog";

export default function PlatformTenants() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const [enums, setEnums] = useState(null);
  const [wizardOpen, setWizardOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/platform/tenants", { params: { search: q } });
      setItems(r.data.items || []);
    } catch (e) {
      notifyError(e, "Gagal memuat daftar tenant");
    } finally {
      setLoading(false);
    }
  }, [q]);

  useEffect(() => {
    // Load enums sekali di mount (source of truth: backend)
    api.get("/platform/tenants/enums").then((r) => setEnums(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <PlatformLayout title="Tenant Management">
      <div data-testid="platform-tenants-page">
        <div className="flex items-center gap-3 mb-4 flex-wrap">
          <div className="relative flex-1 min-w-[220px] max-w-md">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
            <Input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Cari nama / slug / owner / code…"
              className="pl-9 bg-white/5 border-white/10 text-white placeholder:text-white/30"
              data-testid="tenant-search-input"
            />
          </div>
          <span className="text-xs text-white/40">Total: {items.length}</span>
          <Button
            onClick={() => navigate("/platform/tenants/create")}
            className="ml-auto bg-gradient-to-r from-cyan-500 to-purple-500 text-white hover:opacity-90"
            data-testid="btn-create-tenant-from-template"
          >
            <Sparkles size={14} className="mr-1" /> Create From Template
          </Button>
          <Button
            onClick={() => setWizardOpen(true)}
            variant="outline"
            className="border-white/10 bg-transparent text-white hover:bg-white/10"
            data-testid="btn-create-tenant"
          >
            <Plus size={14} className="mr-1" /> Manual
          </Button>
        </div>

        <TenantTable items={items} loading={loading} onDelete={setDeleteTarget} />

        <CreateTenantWizard
          open={wizardOpen}
          onClose={() => setWizardOpen(false)}
          onCreated={() => load()}
          enums={enums}
        />
        <DeleteTenantDialog
          tenant={deleteTarget}
          open={!!deleteTarget}
          onClose={() => setDeleteTarget(null)}
          onDeleted={() => load()}
        />
      </div>
    </PlatformLayout>
  );
}
